import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { updateUserInfoNewsFlag, updateUserInfoName } from '../../api/api';
import { useAtom, atom } from 'jotai'

const fccNewsAtom = atom();
const fccPageAtom = atom();
const userNameAtom = atom();
const userNameKanaAtom = atom();
const seiAtom = atom("");
const meiAtom = atom("");
const seiYomiAtom = atom("");
const meiYomiAtom = atom("");
const companyNameAtom = atom();
const divisionNameAtom = atom();
const emailAtom = atom();
const telNoAtom = atom();

function MainComponent({ handleLoading }) {

    document.title = "利用者情報変更・入力内容の確認| ファーストコンタクトセンター";
    const location = useLocation();
    const navigate = useNavigate();
    const [fccNews, setFccNews] = useAtom(fccNewsAtom)
    const [fccPage, setFccPage] = useAtom(fccPageAtom);
    const [userName, setUserName] = useAtom(userNameAtom);
    const [userNameKana, setUserNameKana] = useAtom(userNameKanaAtom);
    const [sei, setSei] = useAtom(seiAtom);
    const [mei, setMei] = useAtom(meiAtom);
    const [seiYomi, setSeiYomi] = useAtom(seiYomiAtom);
    const [meiYomi, setMeiYomi] = useAtom(meiYomiAtom);
    const [companyName, setCompanyName] = useAtom(companyNameAtom)
    const [divisionName, setDivisionName] = useAtom(divisionNameAtom)
    const [email, setEmail] = useAtom(emailAtom);
    const [telNo, setTelNo] = useAtom(telNoAtom);
    setFccNews(parseInt(location.state.fccNews));
    setUserName(location.state.userName);
    setUserNameKana(location.state.userNameKana);
    setSei(location.state.sei);
    setMei(location.state.mei);
    setSeiYomi(location.state.seiYomi);
    setMeiYomi(location.state.meiYomi);
    setCompanyName(location.state.companyName);
    setDivisionName(location.state.divisionName);
    setEmail(location.state.email);
    setTelNo(location.state.telNo)

    if (fccNews === 1) {
        setFccPage("配信する")
    }
    if (fccNews === 0) {
        setFccPage("配信しない")
    }

    const buttonReturn = () => {
        navigate("/user_info_edit", {
            state: {
                userName,
                userNameKana,
                companyName,
                divisionName,
                email,
                telNo,
                sei: sei,
                mei: mei,
                seiYomi: seiYomi,
                meiYomi: meiYomi,
            }
        })
    }

    const buttonConfirm = async () => {
        let checkIsPb = localStorage.getItem("isPB") === "true";
        let respFlg;
        let respInfoName = true;
        handleLoading(true)
        if (checkIsPb === true) {
            respInfoName = await updateUserInfoName(
                sei.trim(),
                mei.trim(),
                seiYomi.trim(),
                meiYomi.trim(),
                divisionName.trim(),
                telNo.trim()).then(() => {
                    localStorage.setItem("userName", sei.trim() + " " + mei.trim())
                });
        }
        respFlg = await updateUserInfoNewsFlag(fccNews);
        if (respFlg === false || respInfoName === false) {
            alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。");
            handleLoading(false);
            return;
        }
        navigate("/user_info_completion", { state: { page: true } })
        handleLoading(false)

    }


    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">
                <div className="str-inner">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <h2 className="mod-hdg-l2-02">
                        <span>利用者情報変更・入力内容の確認</span>
                    </h2>
                    <input type="hidden" name="user_id" value="" />
                    <div id="user_info" className="mod-tbl-form mb-50">
                        <table role="presentation">
                            <colgroup>
                                <col className="w-35" />
                                <col></col>
                            </colgroup>
                            {(localStorage.getItem("isPB") === "true") === true ?
                                <>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">姓</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div id="sei">
                                                    {sei}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">名</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div id="mei">
                                                    {mei}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">フリガナ（姓）</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div id="seiYomi">
                                                    {seiYomi}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">フリガナ（名）</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div id="meiYomi">
                                                    {meiYomi}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </>
                                :
                                <>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">姓</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div id="sei">
                                                    {sei}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">名</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div id="mei">
                                                    {mei}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">フリガナ（姓）</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div id="seiYomi">
                                                    {seiYomi}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr>
                                            <td className="caption">
                                                <div className="inner">
                                                    <b><span htmlFor="section">フリガナ（名）</span></b>
                                                </div>
                                            </td>
                                            <td>
                                                <div id="meiYomi">
                                                    {meiYomi}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </>
                            }
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">会社名</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="company_name">
                                            {companyName}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">部署名</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="division_name">
                                            {divisionName}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">メールアドレス</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="email">
                                            {email}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">電話番号</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="tel_no">
                                            {telNo}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span htmlFor="section">FCCニュース</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div id="fcc_news">
                                            {fccPage}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="mod-btn of-list">
                        <div className="btn">
                            <button id="btn-go-top" className="of-left"
                                onClick={buttonReturn}>戻る</button>
                        </div>
                        <div className="btn">
                            <button id="btn-send" className="btn_default_select" onClick={buttonConfirm}>登録</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MainComponent;